/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Sampling_BalancedInputs */

const en_ocr_sampling_balanced = /** @type {(inputs: Ocr_Sampling_BalancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1s (Balanced)`)
};

const fr_ocr_sampling_balanced = /** @type {(inputs: Ocr_Sampling_BalancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1s (Équilibré)`)
};

const de_ocr_sampling_balanced = /** @type {(inputs: Ocr_Sampling_BalancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1s (Ausgewogen)`)
};

const it_ocr_sampling_balanced = /** @type {(inputs: Ocr_Sampling_BalancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1s (Bilanciato)`)
};

const ru_ocr_sampling_balanced = /** @type {(inputs: Ocr_Sampling_BalancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 с (сбалансированный)`)
};

const es_ocr_sampling_balanced = /** @type {(inputs: Ocr_Sampling_BalancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1s (Equilibrado)`)
};

const zh_cn2_ocr_sampling_balanced = /** @type {(inputs: Ocr_Sampling_BalancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1秒（平衡）`)
};

const ja_ocr_sampling_balanced = /** @type {(inputs: Ocr_Sampling_BalancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1秒（バランス型）`)
};

const hi_ocr_sampling_balanced = /** @type {(inputs: Ocr_Sampling_BalancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1s (संतुलित)`)
};

const pt_pt2_ocr_sampling_balanced = /** @type {(inputs: Ocr_Sampling_BalancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1s (Equilibrado)`)
};

/**
* | output |
* | --- |
* | "1s (Balanced)" |
*
* @param {Ocr_Sampling_BalancedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_sampling_balanced = /** @type {((inputs?: Ocr_Sampling_BalancedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Sampling_BalancedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_sampling_balanced(inputs)
	if (locale === "de") return de_ocr_sampling_balanced(inputs)
	if (locale === "it") return it_ocr_sampling_balanced(inputs)
	if (locale === "ru") return ru_ocr_sampling_balanced(inputs)
	if (locale === "es") return es_ocr_sampling_balanced(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_sampling_balanced(inputs)
	if (locale === "ja") return ja_ocr_sampling_balanced(inputs)
	if (locale === "hi") return hi_ocr_sampling_balanced(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_sampling_balanced(inputs)
	return en_ocr_sampling_balanced(inputs)
});